import useFetcher from "@/utils/use-fetcher";
import useYWRInfinite from "@/features/ui/hooks/use-ywr-inifite";
import { withPreSignedFetcher } from "@/features/ui/helpers/fetcher-helpers";
import {
  downloadUnoFileKey,
  DownloadUnoFileRequest,
  DownloadUnoFileResponse,
  useDownloadLimitNotice,
} from "@/hooks/use-download-uno-file";
import { useMemo } from "react";

export default function useDownloadUnoFileInfinite() {
  const vanillaFetcher = useFetcher<
    DownloadUnoFileRequest,
    DownloadUnoFileResponse
  >();
  const withLimitNotice = useDownloadLimitNotice();
  const preSignedFetcher = useMemo(() => {
    return withLimitNotice(withPreSignedFetcher(vanillaFetcher));
  }, [vanillaFetcher, withLimitNotice]);

  return useYWRInfinite(downloadUnoFileKey, preSignedFetcher);
}
